import { gql } from "@apollo/client";

export const COTIZACION_FRAGMENT = gql`
  fragment CotizacionFragment on Cotizacion {
    id
    folio
    comentarios
    fechaCreacion
    direccionEnvio {
      id
      nombreDomicilio
    }
    prospecto {
      id
      nombre
      datosFiscalId
      apellidos
      ocupacion
      atendidoPorId
      tipoCliente
      nombreComercial
      razonSocialFiscal
      direccionFiscal {
        id
        direccionTipo
        comentarios
        direccion {
          id
          codigoPostal
          numeroExterior
          numeroInterior
          calle
          colonia
          municipio
          estado
        }
      }
    }
    cotizacionProductos {
      id
      cantidad
      unidadMedidaId
      unidadMedida {
        id
        nombre
      }
      precio
      flete
      fleteUnitario
      total
      subtotal
      subtotal_prod
      iva
      descuento
      descuentoDato
      comentarios
      estatusProducto
      producto {
        id
        codigo
        nombre
        cantidad
        empaque
        marca
        hasIva
        unidadMedidaPresentacion {
          id
          nombre
          acronimo
        }
      }
    }
    direccionLab
    direccion {
      id
      calle
      codigoPostal
      colonia
      numeroExterior
      estado
      municipio
    }
    total
    subtotal_prod
    subtotal
    iva
    flete
    descuento
    vigencia
    estatusCotizacion
    usuario {
      id
      persona {
        nombre
        apellidoPaterno
        apellidoMaterno
      }
    }
  }
`;

export const OBTENER_PAGINADO_COTIZACIONES = gql`
  query CotizacionesPage(
    $query: QueryInput!
    $vendedorId: ID
    $estatus: EstatusCotizacionEnum
    $prospectoId: ID
  ) {
    cotizaciones {
      obtenerPaginado(
        query: $query
        vendedorId: $vendedorId
        estatus: $estatus
        prospectoId: $prospectoId
      ) {
        totalItems
        items {
          ...CotizacionFragment
          prospectoId
        }
      }
    }
  }
  ${COTIZACION_FRAGMENT}
`;

export const OBTENER_COTIZACION_PORID = gql`
  query ObtenerPorIdAsync($id: ID!) {
    cotizaciones {
      obtenerPorIdAsync(id: $id) {
        id
        folio
        razonSocial
        tiempoEntrega
        fechaCreacion
        comentarios
        total
        subtotal_prod
        subtotal
        iva
        flete
        descuento
        prospecto {
          id
          nombre
          apellidos
          ocupacion
          correo
          numeroHA
          numeroSucursales
          razonSocialFiscal
          direccionFiscal {
            id
            direccionTipo
            nombreDomicilio
            comentarios
            direccion {
              id
              codigoPostal
              numeroExterior
              numeroInterior
              calle
              colonia
              municipio
              estado
            }
          }
          listaContactos {
            id
            correo
          }
          atendidoPor {
            persona {
              nombre
              apellidoPaterno
              apellidoMaterno
              telefonoInstitucional
              correoInstitucional
            }
          }
        }
        cotizacionCultivos {
          id
          cultivoId
        }
        direccion {
          id
        }
        cotizacionProductos {
          id
          cantidad
          unidadMedidaId
          unidadMedida {
            id
            nombre
          }
          precio
          flete
          fleteUnitario
          total
          subtotal
          iva
          descuento
          descuentoDato
          comentarios
          subtotal_prod
          producto {
            id
            codigo
            nombre
            cantidad
            empaque
            marca
            unidadMedidaPresentacion {
              id
              nombre
              acronimo
            }
          }
        }
        direccionLab
        direccion {
          calle
          codigoPostal
          colonia
          numeroExterior
          estado
          municipio
        }
        total
        vigencia
        estatusCotizacion
        usuario {
          id
          persona {
            nombre
            apellidoPaterno
            apellidoMaterno
          }
        }
      }
    }
  }
`;


